import { EventNames } from "./types/enums";
import { TrackerType } from "core/state/Trackers/TrackerType";
import { UserInterestPreference } from "shared/request/myHealthyAdvantageApi";
import { appInsights } from "./AppInsights";
import { trackAppEvent } from "./AppInsights";
import { trackGAEvent } from "./GoogleAnalytics";

export type AudioPlayerInteraction = "play" | "pause" | "close" | "done";

export const trackCardClicks = (value: string) => trackEvents(EventNames.CARD_ONCLICK, { value });

export const trackBtnClicks = (value: string) => trackEvents(EventNames.BTN_ONCLICK, { value });

export const trackChartFilter = (value: string) => trackEvents(EventNames.CHART_FILTER, { value });

export const trackSSO = (event: EventNames, provider: string) => trackEvents(event, { provider });

export const trackNavClick = (navigatePath: string) => trackEvents(EventNames.NAV_CLICK, { path: navigatePath });

export const trackAudioPlayerInteraction = (interaction: AudioPlayerInteraction) =>
  trackEvents(EventNames.AUDIO_PLAYER_INTERACTION, { value: interaction });

export const trackAudioPlayerSeek = (playTime: number, duration: number) =>
  trackEvents(EventNames.AUDIO_PLAYER_INTERACTION, { value: "seek", position: duration > 0 ? (playTime / duration).toFixed(2) : "0" });

export const trackEvents = (name: string, properties?: Record<string, string>) => {
  const appEvent = properties
    ? Object.entries(properties)
        .map(([key, value]) => `${key}=${value}`)
        .join("?")
    : "";
  trackGAEvent(name, properties);
  trackAppEvent(`${name}${appEvent && `?${appEvent}`}`);
};

export const trackFilteredInterests = (interestPreferences?: UserInterestPreference[], selectedInterests?: string[]) => {
  const categories = selectedInterests?.map((_category) => interestPreferences?.find((preference) => preference.categoryId === _category)?.name);
  categories?.forEach((category) => trackEvents(EventNames.RESOURCE_FILTER, { value: category ?? "" }));
};

// Never pass personal data (names, contact details, dates of birth, free text) in values: they are sent to App Insights and Google Analytics
export const trackFormSubmission = (name: string, values: Record<string, any> = {}, fromForm?: boolean) => {
  appInsights.trackEvent({ name: `${EventNames.FORM_SUBMIT}?id=${name}` }, { formValues: values });
  !fromForm && trackGAEvent(EventNames.FORM_SUBMIT, { id: name, formValues: JSON.stringify(values) });
};

export const trackAddHealthData = (type: number) => trackBtnClicks(`click_add_${TrackerType[type]}`);

export const trackSaveHealthData = (type: string) => trackEvents(EventNames.HEALTH_DATA_SAVE, { value: type });

export const trackCancelHealthData = (type: number) => trackBtnClicks(`cancel_add_${TrackerType[type]}`);

export const trackClientCodeConflicts = (event: EventNames, signedUpWithSso: boolean, hasSetupSso: boolean) => {
  if (signedUpWithSso) {
    trackEvents(event, { flow: "signed up with SSO" });
  }
  if (hasSetupSso && !signedUpWithSso) {
    trackEvents(event, { flow: "SSO set up" });
  }
};
